'use strict';

import React from 'react';
import classnames from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { OTNavLink } from './tag/OTLink';
import { selectIsHpa } from '../data/hpa/selectors';
import OTIcon from './tag/OTIcon';
import {
  getNotificationCount,
  getNotificationCountWithoutBundled,
} from '../utils/Functions';

class NavigationItem extends React.Component {
  render() {
    let {
      intl,
      isHpa,
      message,
      disabled,
      icon,
      link,
      color,
      isExternal,
      target,
      toggleNavigation,
      notifications,
      logout,
    } = this.props;
    const liClassnames = classnames({
      'ot-nav__item': true,
      'ot-nav__item--green': color === 'green',
    });

    const iconColorMobile = disabled ? 'grey' : color ? 'green' : 'darkblue';

    const linkClassNames = classnames({
      'ot-nav__item__link-wrapper': true,
      'is-disabled': disabled,
    });

    const notificationClassNames = classnames(['ot-nav__item__notification']);

    let linkAttributes = {};
    target && (linkAttributes['target'] = target);

    let _message = message;
    if (isHpa && !!intl.messages[`${_message}.hpa`]) {
      _message = `${_message}.hpa`;
    }

    /* Count multiple omavointi questionnaires as one, because omavointi questionnaires are bundled */
    let notificationCount = getNotificationCountWithoutBundled(
      notifications,
      'OmavointiQuestionnaire'
    );
    return (
      <li className={liClassnames}>
        <OTNavLink
          activeClassName="is-active"
          disabled={disabled}
          link={link}
          isExternal={isExternal}
          className={linkClassNames}
          onClick={(e) => {
            toggleNavigation(e);
          }}
          {...linkAttributes}
        >
          <div className="ot-nav__item__link">
            <div className={'ot-nav__item__icon'} aria-hidden="true">
              <OTIcon
                config={{ ...icon, color: iconColorMobile }}
                className={'inactive-mobile'}
              />
              <OTIcon
                config={{ ...icon, color: 'lightblue' }}
                className={'active-mobile'}
              />
              <OTIcon
                config={{ ...icon, color: 'white' }}
                className={'inactive-desktop'}
              />
              <OTIcon
                config={{ ...icon, color: 'darkblue' }}
                className={'active-desktop'}
              />
            </div>

            <FormattedMessage id={_message} />
            {notificationCount > 0 ? (
              notificationCount === 1 ? (
                <span
                  className={notificationClassNames}
                  aria-label={
                    notificationCount +
                    ' ' +
                    intl.formatMessage({
                      id: 'navigation.notificationDescForOne',
                    })
                  }
                >
                  {notificationCount}
                </span>
              ) : (
                <span
                  className={notificationClassNames}
                  aria-label={
                    notificationCount +
                    ' ' +
                    intl.formatMessage({ id: 'navigation.notificationDesc' })
                  }
                >
                  {notificationCount}
                </span>
              )
            ) : null}
          </div>
        </OTNavLink>
      </li>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isHpa: selectIsHpa(state),
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(NavigationItem)));
